import { lazy, Suspense } from 'solid-js'
import type { FileAttachmentLayout } from './file-attachment-list.tsx'
import { LoadingState } from './state.tsx'

export interface FileDropzoneProps {
  /** Comma-separated accept list, e.g. 'application/pdf,image/*'. */
  accept?: string
  multiple?: boolean
  /** Rejected above this, with a Ukrainian message naming the limit. */
  maxSizeBytes?: number
  disabled?: boolean
  files: File[]
  onFilesChange: (files: File[]) => void
  onReject?: (reason: string, file: File) => void
  label?: string
  hint?: string
  compact?: boolean
  fileLayout?: FileAttachmentLayout
}

const SharedFilePicker = lazy(() =>
  import('../../prototype/components/file-picker.tsx').then((module) => ({
    default: module.FilePicker,
  })),
)

/** Keeps prototype record state out of the low-level UI export graph. */
export const FileDropzone = (props: FileDropzoneProps) => (
  <Suspense fallback={<LoadingState title="Підготовка файлів…" />}>
    <SharedFilePicker {...props} />
  </Suspense>
)
